import React, { ReactElement, useState } from 'react';
import VatAuditReportCriteriaModal from '../../components/modals/VatAuditReportCriteriaModal';
import VatExceptionReportCriteriaModal from '../../components/modals/VatExceptionReportCriteriaModal';
import { IWorkspaceAction } from '../../@types/workspaceTypes';

enum VatTransactionWorkspaceAction {
  VatAuditReport = 'VAT_AUDIT_REPORT',
  VatExceptionReport = 'VAT_EXCEPTION_REPORT',
}

export const workspaceActionsForPermissions = [
  {
    actionReference: VatTransactionWorkspaceAction.VatAuditReport,
  },
  {
    actionReference: VatTransactionWorkspaceAction.VatExceptionReport,
  },
];

export const useVatTransactionActions = (): [actions: Array<IWorkspaceAction>, modals: ReactElement] => {
  const [vatAuditModalOpen, setVatAuditModalOpen] = useState(false);
  const [vatExceptionModalOpen, setVatExceptionModalOpen] = useState(false);

  const vatTransactionActions: Array<IWorkspaceAction> = [
    {
      text: 'Vat Audit Report',
      key: 'vatAuditReport',
      onClick: () => {
        setVatAuditModalOpen(true);
      },
      actionReference: VatTransactionWorkspaceAction.VatAuditReport,
      ignoreBulkActionCheck: true, //This report does not use workspace selections.
    },
    {
      text: 'Vat Exception Report',
      key: 'vatExceptionReport',
      onClick: () => {
        setVatExceptionModalOpen(true);
      },
      actionReference: VatTransactionWorkspaceAction.VatExceptionReport,
      ignoreBulkActionCheck: true, //This report does not use workspace selections.
    },
  ];

  return [
    vatTransactionActions,
    <>
      <VatAuditReportCriteriaModal isOpen={vatAuditModalOpen} onClose={() => setVatAuditModalOpen(false)} />
      <VatExceptionReportCriteriaModal isOpen={vatExceptionModalOpen} onClose={() => setVatExceptionModalOpen(false)} />
    </>,
  ];
};
